import { MasterDataWithRegionalDivisionType } from 'src/models/MasterData'

type PrefecutreByRegion = {
  [key: string]: MasterDataWithRegionalDivisionType[]
}

type categorizePrefecturesByRegionResponse = {
  hokkaidoPrefectures: MasterDataWithRegionalDivisionType[]
  tohokuPrefectures: MasterDataWithRegionalDivisionType[]
  kantoPrefectures: MasterDataWithRegionalDivisionType[]
  chubuPrefectures: MasterDataWithRegionalDivisionType[]
  kinkiPrefectures: MasterDataWithRegionalDivisionType[]
  chugokuPrefectures: MasterDataWithRegionalDivisionType[]
  shikokuPrefectures: MasterDataWithRegionalDivisionType[]
  kyushuPrefectures: MasterDataWithRegionalDivisionType[]
  kaigai: MasterDataWithRegionalDivisionType[]
}

// NOTE: prefecture.regional_division_type を元に各都道府県を地域ごとに分類します
export const categorizePrefecturesByRegion = (
  prefectures: MasterDataWithRegionalDivisionType[],
): categorizePrefecturesByRegionResponse => {
  const prefecturesByRegion: PrefecutreByRegion = {}
  prefectures.forEach((prefecture) => {
    if (!prefecturesByRegion[prefecture.regionalDivisionType])
      prefecturesByRegion[prefecture.regionalDivisionType] = []

    prefecturesByRegion[prefecture.regionalDivisionType].push(prefecture)
  })
  return {
    hokkaidoPrefectures: prefecturesByRegion.hokkaido,
    tohokuPrefectures: prefecturesByRegion.tohoku,
    kantoPrefectures: prefecturesByRegion.kanto,
    chubuPrefectures: prefecturesByRegion.chubu,
    kinkiPrefectures: prefecturesByRegion.kinki,
    chugokuPrefectures: prefecturesByRegion.chugoku,
    shikokuPrefectures: prefecturesByRegion.shikoku,
    kyushuPrefectures: prefecturesByRegion.kyushu,
    kaigai: prefecturesByRegion.kaigai,
  }
}
